import type { IntervalGamePopulated, TeamGamePopulated } from "../shared/interfaces";

export const MLB_LEAGUE_NAME = "MLB";

export const MLB_TERMS_OF_USE_URL = "https://www.mlb.com/official-information/terms-of-use";
export const MLB_PRIVACY_POLICY_URL = "https://www.mlb.com/official-information/privacy-policy";

export function isMlbLeagueName(name?: string | null): boolean {
  return (name || "").trim().toUpperCase() === MLB_LEAGUE_NAME;
}

export function teamHasMlbLeague(leagueNames?: string[] | null): boolean {
  return (leagueNames || []).some(isMlbLeagueName);
}

/** True when the fan session is for an MLB team (welcome context and/or selected game). */
export function isMlbFanContext(opts: {
  selectedGame?: IntervalGamePopulated | null;
  welcomeTeam?: TeamGamePopulated | null;
}): boolean {
  if (isMlbLeagueName(opts.selectedGame?.leagueName)) return true;
  if (teamHasMlbLeague(opts.welcomeTeam?.leagueNames)) return true;
  if (teamHasMlbLeague(opts.selectedGame?.team1?.leagueNames)) return true;
  return false;
}

export function leagueNamesFromTeamLeague(
  league: Array<{ name?: string } | string> | undefined | null,
): string[] {
  if (!league?.length) return [];
  return league
    .map((item) => (typeof item === "string" ? item : item?.name || ""))
    .map((name) => name.trim())
    .filter(Boolean);
}
